const compatModules = {};
import * as Module1 from "./components/dialog-holder";
compatModules["./components/dialog-holder"] = Module1;
import * as Module2 from "./services/dialog";
compatModules["./services/dialog"] = Module2;
export default compatModules;